import { DEFAULT_TIMEZONE } from 'app-config';

import { baseApi } from 'segments/api/baseApi';

import type { AccountData, AccountDataResponse, UserSettings, UserSettingsResponse } from './types';

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    account: builder.query<AccountData, void>({
      query: () => ({
        url: '/user/me',
        method: 'GET',
      }),
      providesTags: ['Auth', 'User'],
      transformResponse: (response: AccountDataResponse): AccountData => ({
        ...response,
        id: response.id.toString(),
      }),
    }),

    getUserSettings: builder.query<UserSettings, void>({
      query: () => ({
        url: '/user/settings',
        method: 'GET',
      }),
      providesTags: ['Auth', 'User'],
      transformResponse: (response: UserSettingsResponse): UserSettings => ({
        colorScheme: response.color_scheme,
        timezone: response.timezone ? Number(response.timezone) : DEFAULT_TIMEZONE,
        lang: response.lang,
        balanceType: response.balance_type,
      }),
    }),

    updateUserSettings: builder.mutation<void, UserSettings>({
      query: (params) => ({
        url: '/user/settings',
        method: 'PUT',
        body: {
          color_scheme: params.colorScheme,
          timezone: params.timezone.toString(),
          lang: params.lang,
          balance_type: params.balanceType,
        }
      }),
      // invalidatesTags: ['UsersList'],
    }),

  }),
});

export const {
  useAccountQuery,
  useGetUserSettingsQuery,
  useUpdateUserSettingsMutation,
} = userApi;
